<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay dashcams' }"
></app-tabla>
